import React from "react";
import { formatEuro } from "@/shared/utils/formatEuro";

type EuroFormatProps = {
  amount: number
  className?: string
};

export const EuroFormat = ({ amount, className }: EuroFormatProps): React.JSX.Element => {
  return <span className={className}>{formatEuro(amount)}</span>;
};
